import fetch from '@/plugin/axios'

// 添加活动
export function addThemeTpl (query) {
  return fetch({
    url: '/api/order/clock-in-theme-tpl/add',
    method: 'Post',
    data: query
  })
}

// 活动列表
export function getThemeTplList (query) {
  return fetch({
    url: '/api/order/clock-in-theme-tpl/list',
    method: 'Post',
    data: query
  })
}

// 模版信息
export function getThemeTplInfo (id) {
  return fetch({
    url: `/api/order/clock-in-theme-tpl/info/${id}`,
    method: 'Get'
  })
}
// 修改模版
export function getThemeTplUpdate (query, id) {
  return fetch({
    url: `/api/order/clock-in-theme-tpl/update/${id}`,
    method: 'Post',
    data: query
  })
}

// 任务模版选项
export function getClockInTplOptions (data) {
  return fetch({
    url: '/api/order/clock-in-theme-tpl/options',
    method: 'Post',
    data: data
  })
}
